import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addMedicationFailure,
  addMedicationSuccess,
  //
  deleteMedicationFailure,
  deleteMedicationSuccess,
  //
  editMedicationFailure,
  editMedicationSuccess,
  //
  fetchMedicationFailure,
  fetchMedicationSuccess,
  //
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_MEDICATION,
  DELETE_MEDICATION,
  EDIT_MEDICATION,
  FETCH_MEDICATION,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchMedicationSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-medication?${query}`,
      payload,
    );
    yield put(fetchMedicationSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchMedicationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching medication!"));
  }
}

export function* getViewDataSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-medication/${payload}`,
    );
    yield put(getViewDataSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addMedicationSaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/resident-medication/add`,
      payload,
    );
    if (data) {
      yield put(successAlert("Medication added successfully!"));
      yield put(addMedicationSuccess());
      typeof onAdd === "function" && onAdd();
    }
  } catch (e) {
    yield put(addMedicationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editMedicationSaga({ payload, onEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/resident-medication/edit/${payload.id}`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("Medication updated successfully!"));
      yield put(editMedicationSuccess());
      typeof onEdit === "function" && onEdit(data);
    }
  } catch (e) {
    yield put(editMedicationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteMedicationSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  try {
    const data = yield call(
      api(token).delete,
      `/api/resident-medication/${payload}`,
    );
    if (data) {
      yield put(successAlert("Medication deleted successfully!"));
      yield put(deleteMedicationSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteMedicationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchMedicationFlow() {
  yield takeEvery(FETCH_MEDICATION, fetchMedicationSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addMedicationFlow() {
  yield takeEvery(ADD_MEDICATION, addMedicationSaga);
}
export function* editMedicationFlow() {
  yield takeEvery(EDIT_MEDICATION, editMedicationSaga);
}
export function* deleteMedicationFlow() {
  yield takeEvery(DELETE_MEDICATION, deleteMedicationSaga);
}

export default function* ResidentMedicationSaga() {
  yield all([
    fetchMedicationFlow(),
    getViewDataFlow(),
    addMedicationFlow(),
    editMedicationFlow(),
    deleteMedicationFlow(),
  ]);
}
